import { QuestionType_Enum_ } from 'models';
import { EsrsReportMetric } from '../../Report.types';
import { addEmptySpace } from '../report-helper-functions';
import { ReportMdrmMetricAnswers } from '../../MetricAnswerCalculation';
import {
  MDRM_QUESTIONS,
  MdrmTypeEnum,
} from 'containers/Esrs/pieces/DisclosureRequirements/Metrics/MDRM';
import { Paragraph } from 'docx';
import { TextStyle } from '../reportThemes';

export const createMetricMdrmAnswers = (mdrmMetricAnswers: ReportMdrmMetricAnswers) => {
  const isEntitySpecific = mdrmMetricAnswers.metric.additionalTypes.some((type) => {
    return type.additionalType.reference === 'Entity-specific';
  });

  const mappedMdrms = MDRM_QUESTIONS.filter((q) => {
    if (q.id === MdrmTypeEnum.entitySpecific) {
      return isEntitySpecific;
    }
    return true;
  })
    .map((q) => {
      return {
        id: q.id,
        question: q.question,
        answer: mdrmMetricAnswers.answers[q.id],
      };
    })
    // Remove opted out MDR-Ms
    .filter((q) => !q.answer?.hasOptedOut);

  const displayedAnswers = mappedMdrms.flatMap((q) => {
    const answer = mdrmMetricAnswers.answers?.[q.id];

    if (!!answer?.value) {
      return [
        new Paragraph({
          text: answer?.value ?? '',
          style: TextStyle.body,
          spacing: {
            after: 100,
          },
        }),
      ];
    }

    return [];
  });

  return displayedAnswers.flat();
};

export const createMdrm = (metric: EsrsReportMetric) => {
  const isNarrativeMetric = metric.metric.metric.metricType !== QuestionType_Enum_.Decimal_;

  if (isNarrativeMetric) return [];

  const metricMdrmDataPoints = metric.mdrmAnswers;

  const mdrmAnswersArray = Object.values(metricMdrmDataPoints.answers);

  const isNotDisclosed = !metric.isMdrmDisclosed;
  const noMdrmAnswered = mdrmAnswersArray.every((answer) => !answer || answer.value === '');
  if (noMdrmAnswered || isNotDisclosed) return [];

  return [createMetricMdrmAnswers(metricMdrmDataPoints), addEmptySpace(100)].flat();
};
